export enum DateTimeRelatesTo {
  departure = 'departure',
  arrival = 'arrival',
}
